<template>
  <span
    class="license-badge"
    :class="`license-badge--${level}`"
  >{{ label }}</span>
</template>

<script>
export default {
  name: "LicenseBadge",
  props: {
    licenses: {
      type: Object,
      required: true
    }
  },
  computed: {
    label() {
      if (this.licenses.unlimited) return "Ilimitado";

      return `${this.licenses.available}/${this.licenses.total}`;
    },
    level() {
      if (this.licenses.unlimited) return "high";
      if (this.licenses.available > 20) return "high";
      if (this.licenses.available >= 1) return "medium";

      return "low";
    }
  }
};
</script>

<style scoped>
.license-badge {
  display: inline-block;
  color: #ffffff;
  font-weight: 700;
  border-radius: 999px;
  padding: 3px 12px;
  font-size: 14px;
}

.license-badge--high {
  background: #4caf50;
}

.license-badge--medium {
  background: #ffc107;
}

.license-badge--low {
  background: #f44336;
}
</style>
